import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import './styles.css';

export default function ProfileArtistHelpProfilePage() {
  const t = useTranslations('artist_help.profile');
  const [openSections, setOpenSections] = useState({
    keyTerms: false,
    claimProfile: false,
    galleryArtistDynamic: false,
    claimedProfileFeatures: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category">
      <header className="artist-help-category__header">
        <GoBackButton alternativeRoute="/profile/artist-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body">
        <section className="artist-help-category__intro">
          <p>{t('intro_p1')}</p>
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('keyTerms')}
            aria-expanded={openSections.keyTerms}
          >
            <h2>{t('sections.key_terms.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.keyTerms ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.keyTerms && (
            <div className="artist-help-category__accordion-content">
              <div className="artist-help-category__terms">
                <article className="artist-help-category__term">
                  <h3>{t('sections.key_terms.represented_artist_title')}</h3>
                  <p>{t('sections.key_terms.represented_artist_p1')}</p>
                </article>

                <article className="artist-help-category__term">
                  <h3>{t('sections.key_terms.work_of_artist_title')}</h3>
                  <p>{t('sections.key_terms.work_of_artist_p1')}</p>
                </article>

                <article className="artist-help-category__term">
                  <h3>{t('sections.key_terms.gallery_owned_title')}</h3>
                  <p>{t('sections.key_terms.gallery_owned_p1')}</p>
                </article>

                <article className="artist-help-category__term">
                  <h3>{t('sections.key_terms.suarteworld_title')}</h3>
                  <p>{t('sections.key_terms.suarteworld_p1')}</p>
                </article>

                <article className="artist-help-category__term">
                  <h3>{t('sections.key_terms.artlists_title')}</h3>
                  <p>{t('sections.key_terms.artlists_p1')}</p>
                </article>

                <article className="artist-help-category__term">
                  <h3>{t('sections.key_terms.suarte_road_title')}</h3>
                  <p>{t('sections.key_terms.suarte_road_p1')}</p>
                </article>

                <article className="artist-help-category__term">
                  <h3>{t('sections.key_terms.verified_artist_insignia_title')}</h3>
                  <p>{t('sections.key_terms.verified_artist_insignia_p1')}</p>
                </article>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('claimProfile')}
            aria-expanded={openSections.claimProfile}
          >
            <h2>{t('sections.claim_profile.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.claimProfile ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.claimProfile && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.claim_profile.intro_p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.claim_profile.how_claiming_title')}</h3>
                <ul>
                  <li>{t('sections.claim_profile.how_claiming_list_1')}</li>
                  <li>{t('sections.claim_profile.how_claiming_list_2')}</li>
                  <li>{t('sections.claim_profile.how_claiming_list_3')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.claim_profile.good_to_know_title')}</h3>
                <ul>
                  <li>{t('sections.claim_profile.good_to_know_list_1')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.claim_profile.cant_claim_title')}</h3>
                <ul>
                  <li>{t('sections.claim_profile.cant_claim_list_1')}</li>
                  <li>{t('sections.claim_profile.cant_claim_list_2')}</li>
                  <li>{t('sections.claim_profile.cant_claim_list_3')}</li>
                </ul>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('galleryArtistDynamic')}
            aria-expanded={openSections.galleryArtistDynamic}
          >
            <h2>{t('sections.gallery_artist_dynamic.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.galleryArtistDynamic ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.galleryArtistDynamic && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.gallery_artist_dynamic.intro_p1')}</p>
              <ul>
                <li>{t('sections.gallery_artist_dynamic.list_1')}</li>
                <li>{t('sections.gallery_artist_dynamic.list_2')}</li>
                <li>{t('sections.gallery_artist_dynamic.list_3')}</li>
              </ul>

              <div className="artist-help-category__note">
                <h3>{t('sections.gallery_artist_dynamic.important_title')}</h3>
                <p>{t('sections.gallery_artist_dynamic.important_p1')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('claimedProfileFeatures')}
            aria-expanded={openSections.claimedProfileFeatures}
          >
            <h2>{t('sections.claimed_profile_features.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.claimedProfileFeatures ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.claimedProfileFeatures && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.claimed_profile_features.intro_p1')}</p>
              <ul>
                <li>{t('sections.claimed_profile_features.list_1')}</li>
                <li>{t('sections.claimed_profile_features.list_2')}</li>
                <li>{t('sections.claimed_profile_features.list_3')}</li>
                <li>{t('sections.claimed_profile_features.list_4')}</li>
                <li>{t('sections.claimed_profile_features.list_5')}</li>
                <li>{t('sections.claimed_profile_features.list_6')}</li>
              </ul>

              <div className="artist-help-category__stack">
                <h3>{t('sections.claimed_profile_features.extra_tools_title')}</h3>
                <ul>
                  <li>{t('sections.claimed_profile_features.extra_tools_list_1')}</li>
                  <li>{t('sections.claimed_profile_features.extra_tools_list_2')}</li>
                </ul>
              </div>

              <div className="artist-help-category__note">
                <h3>{t('sections.claimed_profile_features.verified_insignia_title')}</h3>
                <p>{t('sections.claimed_profile_features.verified_insignia_p1')}</p>
              </div>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
